//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../no/SketchExpressionModifierBuilder.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/SketchExpressionModifierBuilder.js";
let d=[[[0,"AttributeMaterial",1,0],[0,"AttributeName",1,0],[0,"CoordSystem",1,"CoordinateSystem",0],[1,"HeelOffset",0,"Expression",0],[0,"HeelPoint",1,"Point",0],[0,"KeepCoordSystem",1,0],[0,"KeepHeelPoint",1,0],[0,"KeepPlacementPlane",1,0],[0,"KeepReferencePlane",1,0],[0,"KeepReverseDirection",1,0],[0,"KeepSelectTrimFace",1,0],[0,"PlacementPlane",1,"Plane",0],[0,"PlacementType",1,0],[0,"ReferencePlane",1,"Plane",0],[0,"ReverseDirection",1,0],[0,"SelectTrimFace",0,"ScCollector",0],[1,"SketchBlock",0,"SketchExpressionModifierBuilder",0],[1,"Thickness",0,"Expression",0]],[[["num_names"],"GetAvailableAttributeNames",{R_:{names:""}},0,0],[["num_materials"],"GetAvailableAttributeMaterials",{R_:{materials:""}},0,0]],[]];
SPLM.Features.ShipDesign.CustomBracketBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.CustomBracketBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.CustomBracketBuilder.CreationMethod = Object.freeze({
    "PlanesAndPoint" : "PlanesAndPoint", "SpecifyCSYS" : "SpecifyCSYS"});

export default SPLM;